import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { makeStyles } from '@material-ui/styles';
import {
    Card,
    CardContent,
    CardMedia,
    Typography,
    Divider,
    Link,
    Avatar
} from '@material-ui/core';
import LockIcon from '@material-ui/icons/Lock';

import From from '../Login/components/From/From';

export default function Login() {

    const useStyles = makeStyles(theme => ({

        root: {
            height: '80%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            margin: '4%'
            // padding: theme.spacing(6, 2)
        },

        card: {
            width: theme.breakpoints.values.sm,
            maxWidth: '100%',
            overflow: 'unset',
            display: 'flex',
            position: 'relative',
            '& > *': {
                flexGrow: 1,
                flexBasis: '50%',
                width: '50%'
            }
        },

        content: {
            padding: theme.spacing(8, 4, 3, 4),

        },

        media: {
            borderTopRightRadius: 4,
            borderBottomRightRadius: 4,
            // padding: theme.spacing(3),
            color: theme.palette.white,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'flex-end',
            [theme.breakpoints.down('md')]: {
                display: 'none'
            }
        },

        loginForm: {
            marginTop: theme.spacing(3)
        },

        divider: {
            margin: theme.spacing(2, 0)
        },

        media: {
            position: 'absolute',
            width: '100%',
            top: '0',
        },

        imageIcon: {
            width: '100px',
            height: '100px'
        }



    }));

    const classes = useStyles();

    return (
        <div
            className={classes.root}
            title="Login"
        >
            <Card className={classes.card}>
                <div className={classes.media}>
                    <img style={{
                        marginLeft: 25,width:"20%"
                    }} src={require("../../assets/logo.png")} />
                </div>

                <CardContent className={classes.content}>

                    <Typography
                        gutterBottom
                        variant="h3"
                        style={{
                            marginLeft: "30%"
                        }}
                    >
                        Sign in
                    </Typography>
                    <Typography variant="subtitle2"
                        style={{
                            marginLeft: "30%"
                        }}
                    >
                        Sign in on the internal platform
                    </Typography>
                    <div
                        style={{
                            width: "70%",
                            marginLeft: "30%"
                        }}
                    >
                        <From className={classes.loginForm} />
                    </div>


                    <Divider className={classes.divider} />

                    {/* <Link
                        align="center"
                        color="secondary"
                        component={RouterLink}
                        to="/auth/register"
                        underline="always"
                        variant="subtitle2"
                    >
                        Don't have an account?
                    </Link> */}
                </CardContent>

            </Card>
        </div>
    );
}
